import { bannerError } from 'client-portal/utils/error-handling';
import { namespace } from 'client-portal/adapters/application';
import Service, { service } from '@ember/service';

export default class SignOutService extends Service {
  @service store;
  @service session;
  @service intl;
  @service clientAppBanner;

  async signOut(options = {}) {
    const { afterSignOut, showBanner = false } = options;

    try {
      let adapter = this.store.adapterFor('application');
      await adapter.ajax(`/${namespace}/sessions`, 'DELETE', {});

      this.session.set('_noInvalidationBanner', !showBanner);
      this.clientAppBanner.resetDismiss();

      this.session.invalidate();

      if (afterSignOut && typeof afterSignOut === 'function') {
        afterSignOut();
      }
    } catch (err) {
      bannerError(err, { title: this.intl.t('messages.error.signOutFailed') });
      throw err;
    }
  }

  async signOutWithBanner(afterSignOut) {
    return this.signOut({ afterSignOut, showBanner: true });
  }

  async signOutSilently(afterSignOut) {
    return this.signOut({ afterSignOut, showBanner: false });
  }
}
